import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Contract } from '../store';
import { Account } from '../../store';
import { AccountContract } from '../../store/account-contract.model';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { ResponseStatus, IStatusMessage } from '../../../shared';
import { ReplaySubject } from 'rxjs';
import { IShowErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-accounts-receivable-contract',
    templateUrl: './accounts-receivable-contract.component.html',
    styleUrls: ['./accounts-receivable-contract.component.scss'],
    standalone: false
})
export class AccountsReceivableContractComponent implements OnInit {
    @Input() accounts: SelectItem[];
    @Input() items: AccountContract[];
    private _selectedError: IStatusMessage;
    @Input() public set selectedError(value: IStatusMessage) {
        this.log.verbose({
            type: 'AccountsReceivableContractComponent:selectedError:set',
            value,
        });
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) { return; }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        this.log.verbose({
            type: 'AccountsReceivableContractComponent:selectedError',
            value,
            row
        });
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    @Output() SaveAccountContract = new ReplaySubject<AccountContract[]>(1);
    cloned: { [i: string]: AccountContract } = {};
    editing: AccountContract;

    constructor(private log: LoggingService) {}

    ngOnInit() {}
    onRowEditInit(item: AccountContract) {
        this.cloned[item.Contractlistid] = { ...item };
        this.editing = item;
        this.log.verbose({
            type: 'AccountsReceivableContractComponent:onRowEditInit',
            item,
            clonedAccountAllocations: this.cloned,
            editing: this.editing
        });
    }
    onRowEditSave(item: AccountContract) {
        this.log.verbose({
            type: 'AccountsReceivableContractComponent:onRowEditSave',
            r: item,
            clonedAccountAllocations: this.cloned
        });
        item.Status.StatusCode = ResponseStatus.Loading;
        item.Status.Message = 'Saving';

        this.SaveAccountContract.next([item]);
        delete this.cloned[item.Contractlistid];
        delete this.editing;
    }
    onRowEditCancel(item: AccountContract) {
        this.log.verbose({
            type: 'AccountsReceivableContractComponent:onRowEditCancel',
            r: item,
            clonedAccountAllocations: this.cloned
        });
        const index = this.items.findIndex(
            x => x.Contractlistid === item.Contractlistid
        );
        if (index >= 0) {
            this.items.splice(index, 1, this.cloned[item.Contractlistid]);
        }
        this.items = [...this.items];
        this.items = [...this.items];


        delete this.cloned[item.Contractlistid];
        delete this.editing;
    }
    onStatusClick(item: AccountContract) {
        this.log.verbose({
            type: 'AccountsReceivableContractComponent:onStatusClick',
            item
        });
        this.ShowError.emit({ open: true, MsgEntityID: item.Contractlistid });
    }
}
